import { gql } from '@apollo/client';

export default gql`
  mutation CreateLesson(
    $courseId: String!
    $groupId: String!
    $lessonId: String!
  ) {
    lesson(courseId: $courseId, groupId: $groupId, lessonId: $lessonId)
      @rest(
        type: "Lesson"
        path: "courses/{args.courseId}/groups/{args.groupId}/lessons/{args.lessonId}"
        method: "DELETE"
      ) {
      _id
    }
  }
`;
